import React from "react";
import { GsdDemoModeBanner } from "./KarateDemoModeBanner.jsx";
import { GsdTopNavGroups } from "../../node_modules/@pws/coquille-app-shell/src/components/GsdRoleTabs.jsx";
import { GsdMobileNav } from "../../node_modules/@pws/coquille-app-shell/src/components/GsdMobileNav.jsx";
import { getLocaleLabel } from "../../node_modules/@pws/coquille-app-shell/src/config/resolveNavigation.js";

/**
 * Header GSD localisé — remplace GsdTopHeader (Menu / déconnexion / bannière démo).
 */
export function GsdTopHeader({
  config,
  locale = "fr",
  activeRole,
  isAuthenticated = false,
  userDisplayName,
  version,
  brand,
  brandHref = "/",
  languageToggle,
  helpSlot,
  trainingSlot,
  onLogout,
  loginSlot,
  navGroups = [],
  renderNavLink,
  isItemActive,
  mobileNavOpen = false,
  onMobileNavToggle,
  layoutVariant = "top-nav",
  hideHeaderNav = false,
  userContextSlot,
  roleSwitcherSlot,
  mobileNavItems,
  testId = "gsd-top-header",
}) {
  const phaseLabel = getLocaleLabel(
    { labelFr: config.phaseLabel?.fr, labelEn: config.phaseLabel?.en },
    locale,
  );
  const demoMessage = getLocaleLabel(
    { labelFr: config.demoBanner?.fr, labelEn: config.demoBanner?.en },
    locale,
  );
  void phaseLabel;
  void demoMessage;
  const menuLabel = locale === "en" ? "Menu" : "Menu";
  const logoutLabel = locale === "en" ? "Log out" : "Déconnexion";

  return (
    <header className="gsd-top-header" data-testid={testId}>
      <div className="gsd-top-header__accent" aria-hidden="true" />
      <div className="gsd-top-header__inner">
        {brand ? (
          brand
        ) : (
          <a href={brandHref} className="gsd-top-header__brand" data-testid="gsd-brand-link">
            <span className="gsd-top-header__brand-main">{config.appShortName || config.appName}</span>
            <span className="gsd-top-header__brand-sub">{config.appName}</span>
          </a>
        )}

        <button
          type="button"
          className="gsd-top-header__mobile-toggle"
          aria-expanded={mobileNavOpen}
          aria-controls="gsd-mobile-nav-panel"
          onClick={onMobileNavToggle}
          data-testid="gsd-mobile-nav-toggle"
        >
          {menuLabel}
        </button>

        {layoutVariant === "top-nav" && !hideHeaderNav ? (
          <GsdTopNavGroups
            groups={navGroups}
            renderLink={renderNavLink}
            isItemActive={isItemActive}
            className={mobileNavOpen ? "gsd-top-nav--open" : ""}
            testId="gsd-main-nav"
          />
        ) : null}

        <div className="gsd-top-header__actions" data-testid="gsd-header-actions">
          {roleSwitcherSlot}
          {languageToggle}
          {helpSlot}
          {isAuthenticated ? (
            <>
              {userContextSlot}
              {onLogout ? (
                <button type="button" className="gsd-top-header__logout" onClick={onLogout} data-testid="gsd-header-logout-btn">
                  {logoutLabel}
                </button>
              ) : null}
            </>
          ) : (
            loginSlot
          )}
        </div>
      </div>

      <GsdDemoModeBanner mode={config.mode || "production"} />

      <GsdMobileNav
        open={mobileNavOpen}
        onClose={() => onMobileNavToggle?.()}
        groups={navGroups}
        flatItems={mobileNavItems}
        renderLink={renderNavLink}
        isItemActive={isItemActive}
        activeRole={null}
        helpSlot={helpSlot}
        trainingSlot={null}
      />
    </header>
  );
}
